import type { CSSProperties, ReactNode } from 'react';
import classes from '../../theme/broker.module.css';
import { CONSOLE_FONT_STACK } from '../../theme/typeface';

/**
 * The console's face for every Mantine control inside the experience. Mantine's own default is the system stack, which
 * is what a text box or a select falls back to when nothing names a face, so the page's Roboto would stop at the
 * label. Set on the ground, not in the theme: a theme's font is written to `:root`, where it reaches the whole page.
 */
const FACE = {
  '--mantine-font-family': CONSOLE_FONT_STACK,
  '--mantine-font-family-headings': CONSOLE_FONT_STACK,
} as CSSProperties;

interface BrokerGroundProps {
  readonly embedded: boolean;
  readonly children: ReactNode;
}

/**
 * What the experience renders on: a column that fills the window, or the host's layout when embedded. It sets nothing
 * of Mantine's but the face, so every control, size and corner is the console's own.
 */
export function BrokerGround({ embedded, children }: BrokerGroundProps) {
  return (
    <div
      className={classes.ground}
      style={FACE}
      data-embedded={embedded || undefined}
    >
      <div className={classes.content}>{children}</div>
    </div>
  );
}
